import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../../store/authStore'
import { scanDiffApi } from '../../services/api/scanDiff.api'
import type { AssetType } from '../../app/modules/types/scanDiff'

/**
 * Hook for fetching scan diff comparison data for an asset
 * Requires at least 2 scan IDs to be enabled
 */
export function useScanDiff(
  assetId: string | null,
  scanIds: string[],
  assetType: AssetType,
  enabled: boolean = true
) {
  const orgId = useAuthStore((state) => state.orgId)
  const scanIdsKey = scanIds.join(',')

  return useQuery({
    queryKey: [orgId, 'scanDiff', assetType, assetId, scanIdsKey],
    queryFn: () =>
      assetType === 'asset'
        ? scanDiffApi.getAssetDiff(assetId!, scanIds)
        : scanDiffApi.getIpDiff(assetId!, scanIds),
    enabled: enabled && !!assetId && scanIds.length >= 2 && !!orgId,
  })
}
